var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("This is an about page")]),_c('router-link',{attrs:{"to":"/about"}},[_vm._v("Go to About")]),_c('br'),_c('router-link',{attrs:{"to":"/about/bob"}},[_vm._v("Go to About/Bob")]),_c('br'),_c('router-link',{attrs:{"to":"/about/joe"}},[_vm._v("Go to About/Joe")]),_c('br')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }